import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { EntityTaskListApi } from 'api';

export const findEntityTaskList = createAsyncThunk(
  'entityTask/findEntityTaskList',
  async (option: any, { rejectWithValue }) => {
    try {
      const response = await EntityTaskListApi.find(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const createEntityTaskList = createAsyncThunk(
  'entityTask/createEntityTaskList',
  async (body: any, { rejectWithValue }) => {
    try {
      const response = await EntityTaskListApi.create(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findOneEntityTaskList = createAsyncThunk(
  'entityTask/findOneEntityTaskList',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id } = params;
      const response = await EntityTaskListApi.findOne(id);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateEntityTaskList = createAsyncThunk(
  'entityTask/updateEntityTaskList',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id, body } = params;
      const response = await EntityTaskListApi.update(id, body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteEntityTaskList = createAsyncThunk(
  'entityTask/deleteEntityTaskList',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await EntityTaskListApi.delete(id);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface IState {
  entityTasks: Array<any>;
  isFirstLoading: boolean;
  reloadFlag: boolean;
}

const initialState: IState = {
  entityTasks: [],
  isFirstLoading: false,
  reloadFlag: false,
};

const entityTaskListSlice = createSlice({
  name: 'branch',
  initialState,
  reducers: {
    reloadEntityTaskList(state) {
      state.reloadFlag = !state.reloadFlag;
    },
  },
  extraReducers: builder => {
    builder.addCase(findEntityTaskList.fulfilled, (state, action) => {
      const { data } = action.payload;

      const newData = data.map(item => {
        return {
          ...item,
          key: item.id,
          value: item.id,
        };
      });

      state.entityTasks = newData;
      state.isFirstLoading = true;
    });
    builder.addCase(createEntityTaskList.fulfilled, (state, action) => {
      const { payload } = action;
      state.entityTasks = [payload, ...state.entityTasks];
    });
    builder.addCase(updateEntityTaskList.fulfilled, (state, action) => {
      const { data } = action.payload;
      state.entityTasks = state.entityTasks.map((item: any) =>
        item.id == data.id ? data : item
      );
    });
  },
});

const { actions, reducer: entityTaskListReducer } = entityTaskListSlice;

export const { reloadEntityTaskList } = actions;

export default entityTaskListReducer;
